import type {
  CatalogReference,
  ItemType as ItemTypeV1,
} from '@wix/auto_sdk_ecom_current-cart';

export const getCatalogAppIdsV1 = (
  items?: { catalogReference?: CatalogReference }[],
): string => {
  return getMappedUniqueList(
    items,
    ({ catalogReference }) => catalogReference?.appId,
  );
};

export const getItemTypesV1 = (items?: { itemType?: ItemTypeV1 }[]): string => {
  return getMappedUniqueList(items, ({ itemType }) => itemType?.preset);
};

export const getItemsCountV1 = (items?: { quantity?: number }[]): number => {
  /* istanbul ignore next */
  return items?.reduce((count, item) => count + (item.quantity ?? 0), 0) ?? 0;
};

function getMappedUniqueList<T>(
  arr: T[] | undefined,
  mapper: (t: T) => string | undefined | null,
): string {
  return getUniques(
    (arr ?? /* istanbul ignore next */ [])
      .map(mapper)
      .filter(isDefined) as string[],
  ).toString();
}

const getUniques = (arr: string[]): string[] => {
  return [...new Set([...arr])];
};

const isDefined = <T>(obj: T): boolean => {
  return !!obj;
};
